import React from "react";
import { ArrowRight, MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SobreCiteling() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section data-section-id="36363" id="resumen-del-curso" className="bg-background text-foreground py-32 overflow-hidden relative">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {}
          <div ref={ref} className={`lg:col-span-6 flex flex-col justify-center transition-all duration-1000 ease-[cubic-bezier(0.4,0,0.2,1)] ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <h1 className="font-sans font-extrabold tracking-tight text-foreground text-4xl md:text-5xl lg:text-6xl leading-tight mb-6">
              Técnico en Energía Solar
            </h1>
            <p className="font-sans font-normal text-muted-foreground text-lg md:text-xl leading-relaxed mb-8 max-w-lg">
              Uruguay lidera la transición hacia matrices energéticas sostenibles. Formate en la instalación y mantenimiento de sistemas fotovoltaicos con estándares internacionales, dominando la tecnología que impulsa el futuro del país.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link to="https://mpago.la/1WfMEZk" newTab>
                <Button size="lg" className="group text-base font-semibold h-12 bg-[#009EE3] hover:bg-[#008ED2] text-white border-none shadow-md rounded-xl transition-all duration-300">
                  Inscribirme ahora
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
              <Link to="https://wa.me/59896344395" newTab>
                <Button size="lg" className="group text-base font-semibold h-12 bg-[#25D366] hover:bg-[#22c35e] text-white border-none shadow-md rounded-xl transition-all duration-300">
                  <MessageCircle className="w-5 h-5 mr-2" />
                  Consultar por WhatsApp
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-6 relative">
            <div className={`relative rounded-[24px] overflow-hidden shadow-2xl transition-all duration-1000 delay-300 ease-[cubic-bezier(0.4,0,0.2,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/solar-installation-tech.png" alt="Técnico instalando un panel solar monocristalino de alta eficiencia" className="w-full h-auto object-cover aspect-[4/3] bg-muted grayscale-[20%] sepia-[10%] brightness-[95%]" />
              {}
              <div className="absolute inset-0 ring-1 ring-inset ring-primary/20 bg-primary/5 rounded-[24px] pointer-events-none" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}